import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'helpers/hooks';
import { getUserData } from 'selectors/user';
import { getUserStripeCustomerPortal, postUserStripeCustomer } from 'store/user/actions';
import { ModalComponent } from 'components/Modal';
import Loader from 'components/Loader';

interface UpdatePaymentMethodCTAProps {
  hasActiveStripeSubscriptions: boolean;
  paymentMethodUpdateUrl: string;
  setPaymentMethodUpdateUrl: React.Dispatch<React.SetStateAction<string>>;
  paymentMethodError: string;
  setPaymentMethodError: React.Dispatch<React.SetStateAction<string>>;
}

export const UpdatePaymentMethodCTA: React.FC<UpdatePaymentMethodCTAProps> = ({
  hasActiveStripeSubscriptions,
  paymentMethodUpdateUrl,
  setPaymentMethodUpdateUrl,
  paymentMethodError,
  setPaymentMethodError,
}) => {
  const dispatch = useAppDispatch();
  const userData = useAppSelector(getUserData);
  const [isStripeCustomerLoading, setIsStripeCustomerLoading] = useState(false);

  const handlePaymentMethodUpdate = async () => {
    try {
      if (userData.email && !userData.stripe_customer_id) {
        setIsStripeCustomerLoading(true);
        await dispatch(
          postUserStripeCustomer({
            name: `${userData.first_name} ${userData.last_name}`,
            email: userData.email,
          })
        );
      }

      const response = await getUserStripeCustomerPortal({
        return_url: window.location.href,
      });

      if (response.data?.url) {
        setPaymentMethodUpdateUrl(response.data.url);
        window.location.href = response.data.url;
        return;
      }
    } catch {
      setPaymentMethodError('Sorry, we are unable to update your payment method.');
    }
    setIsStripeCustomerLoading(false);
  };

  const label = `Update Payment Methods${hasActiveStripeSubscriptions ? ' and Subscriptions' : ''}`;

  return (
    <>
      <ModalComponent
        contentLabel="configuring stripe settings"
        isOpen={isStripeCustomerLoading}
        style={{ maxWidth: '325px', height: 'fit-content', padding: '27px 23px 9px' }}
      >
        <span className="body-small-text color-inkBlue text-center mb14">
          Setting up your payment settings...
        </span>
        <div className="text-center full-width">
          <Loader width={60} height={60} />
        </div>
      </ModalComponent>

      {paymentMethodError ? (
        <span className="color-errorRed body-small-text">{paymentMethodError}</span>
      ) : paymentMethodUpdateUrl ? (
        <a href={paymentMethodUpdateUrl}>
          <span className="body-small-text color-inkBlue link-text">{label}</span>
        </a>
      ) : (
        <button
          type="button"
          onClick={handlePaymentMethodUpdate}
          disabled={isStripeCustomerLoading}
          className="button-link body-small-text color-inkBlue link-text text-left"
        >
          {label}
        </button>
      )}
    </>
  );
};
